import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon-area-dashboard.svg'
import _imports_1 from '@/assets/icon-area-dashboard-active.svg'
import _imports_2 from '@/assets/area/icon-l-w.svg'
import _imports_3 from '@/assets/area/icon-l-active.svg'
import _imports_4 from '@/assets/area/icon-ranking-w.svg'
import _imports_5 from '@/assets/area/icon-ranking-active.svg'
import _imports_6 from '@/assets/area/icon-car-w.svg'
import _imports_7 from '@/assets/area/icon-car-active.svg'
import _imports_8 from '@/assets/area/icon-facility-w.svg'
import _imports_9 from '@/assets/area/icon-facility-active.svg'
import _imports_10 from '@/assets/area/icon-clock-w.svg'
import _imports_11 from '@/assets/area/icon-clock-active.svg'
import _imports_12 from '@/assets/area/icon-people-w.svg'
import _imports_13 from '@/assets/area/icon-people-active.svg'
import _imports_14 from '@/assets/icon-line-chart.svg'
import _imports_15 from '@/assets/icon-line-chart-active.svg'
import _imports_16 from '@/assets/btn_close-w.svg'


const _withScopeId = n => (_pushScopeId("data-v-1052b5a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "jr-w-full jr-cursor-pointer jr-relative" }
const _hoisted_2 = {
  class: "jr-mr-6",
  src: _imports_0,
  alt: "icon area dashboard"
}
const _hoisted_3 = {
  class: "jr-mr-6",
  src: _imports_1,
  alt: "icon area dashboard active"
}
const _hoisted_4 = { class: "jr-text-sm-1 jr-font-medium jr-inline-block jr-align-middle" }
const _hoisted_5 = {
  key: 0,
  class: "jr-w-full jr-cursor-pointer jr-relative"
}
const _hoisted_6 = {
  src: _imports_2,
  class: "jr-pr-6",
  alt: "icon l w"
}
const _hoisted_7 = {
  src: _imports_3,
  class: "jr-pr-6",
  alt: "icon l active"
}
const _hoisted_8 = {
  class: "jr-mr-3",
  src: _imports_4,
  alt: "icon ranking"
}
const _hoisted_9 = {
  class: "jr-mr-3",
  src: _imports_5,
  alt: "icon ranking active"
}
const _hoisted_10 = { class: "jr-text-xs jr-font-medium jr-inline-block jr-align-middle" }
const _hoisted_11 = {
  src: _imports_2,
  class: "jr-pr-6",
  alt: "icon l w"
}
const _hoisted_12 = {
  src: _imports_3,
  class: "jr-pr-6",
  alt: "icon l active"
}
const _hoisted_13 = {
  class: "jr-mr-3",
  src: _imports_6,
  alt: "icon car"
}
const _hoisted_14 = {
  class: "jr-mr-3",
  src: _imports_7,
  alt: "icon car active"
}
const _hoisted_15 = { class: "jr-text-xs jr-font-medium jr-inline-block jr-align-middle" }
const _hoisted_16 = {
  src: _imports_2,
  class: "jr-pr-6",
  alt: "icon l w"
}
const _hoisted_17 = {
  src: _imports_3,
  class: "jr-pr-6",
  alt: "icon l active"
}
const _hoisted_18 = {
  class: "jr-mr-3",
  src: _imports_8,
  alt: "icon facility"
}
const _hoisted_19 = {
  class: "jr-mr-3",
  src: _imports_9,
  alt: "icon facility active"
}
const _hoisted_20 = { class: "jr-text-xs jr-font-medium jr-inline-block jr-align-middle" }
const _hoisted_21 = {
  src: _imports_2,
  class: "jr-pr-6",
  alt: "icon l w"
}
const _hoisted_22 = {
  src: _imports_3,
  class: "jr-pr-6",
  alt: "icon l active"
}
const _hoisted_23 = {
  class: "jr-mr-3",
  src: _imports_10,
  alt: "icon clock"
}
const _hoisted_24 = {
  class: "jr-mr-3",
  src: _imports_11,
  alt: "icon clock active"
}
const _hoisted_25 = { class: "jr-text-xs jr-font-medium jr-inline-block jr-align-middle" }
const _hoisted_26 = {
  src: _imports_2,
  class: "jr-pr-6",
  alt: "icon l w"
}
const _hoisted_27 = {
  src: _imports_3,
  class: "jr-pr-6",
  alt: "icon l active"
}
const _hoisted_28 = {
  class: "jr-mr-3",
  src: _imports_12,
  alt: "icon people"
}
const _hoisted_29 = {
  class: "jr-mr-3",
  src: _imports_13,
  alt: "icon people active"
}
const _hoisted_30 = { class: "jr-text-xs jr-font-medium jr-inline-block jr-align-middle" }
const _hoisted_31 = {
  key: 0,
  class: "jr-loader jr-ease-linear jr-rounded-full jr-border-4 jr-border-t-4 jr-border-gray-200 jr-h-6 jr-w-6 jr-my-3.5 jr-mx-5"
}
const _hoisted_32 = {
  class: "jr-mr-6",
  src: _imports_14,
  alt: "icon line chart"
}
const _hoisted_33 = {
  class: "jr-mr-6",
  src: _imports_15,
  alt: "icon line chart active"
}
const _hoisted_34 = { class: "jr-text-sm-1 jr-font-medium jr-inline-block jr-align-middle" }
const _hoisted_35 = { class: "close" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_16,
  alt: "btn close"
}, null, -1))
const _hoisted_37 = [
  _hoisted_36
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    "data-html2canvas-ignore": "true",
    class: "right_column jr-fixed jr-z-10 jr-top-0 jr-left-0 jr-h-screen jr-bg-primary jr-shadow-lg",
    style: _normalizeStyle({ width: _ctx.sbMinimum ? '64px' : '240px' })
  }, [
    _createElementVNode("ul", null, [
      _createElementVNode("li", _hoisted_1, [
        _createVNode(_component_router_link, {
          to: "/area_report",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClickLink('ダッシュボード')))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["jr-p-6 jr-flex jr-items-center", { 'jr-bg-primary-light jr-text-primary': _ctx.isDashboard, 'jr-text-white': !_ctx.isDashboard }])
            }, [
              _withDirectives(_createElementVNode("img", _hoisted_2, null, 512), [
                [_vShow, !_ctx.isDashboard]
              ]),
              _withDirectives(_createElementVNode("img", _hoisted_3, null, 512), [
                [_vShow, _ctx.isDashboard]
              ]),
              _withDirectives(_createElementVNode("h1", _hoisted_4, "ダッシュボード", 512), [
                [_vShow, !_ctx.sbMinimum]
              ])
            ], 2)
          ]),
          _: 1
        })
      ]),
      (!_ctx.isDashboard)
        ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/area_report/ranking",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickLink('エリア来訪者の居住地／勤務地ランキング')))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["jr-py-3.5 jr-px-5.5 jr-flex jr-items-center", { 'jr-bg-primary-light jr-text-primary': _ctx.isRanking, 'jr-text-white': !_ctx.isRanking }])
                }, [
                  _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [
                    [_vShow, !_ctx.sbMinimum && !_ctx.isRanking]
                  ]),
                  _withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [
                    [_vShow, !_ctx.sbMinimum && _ctx.isRanking]
                  ]),
                  _withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [
                    [_vShow, !_ctx.isRanking]
                  ]),
                  _withDirectives(_createElementVNode("img", _hoisted_9, null, 512), [
                    [_vShow, _ctx.isRanking]
                  ]),
                  _withDirectives(_createElementVNode("h1", _hoisted_10, "エリア来訪者の居住地／勤務地ランキング", 512), [
                    [_vShow, !_ctx.sbMinimum]
                  ])
                ], 2)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/area_report/transportation",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClickLink('交通手段比率')))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["jr-py-3.5 jr-px-5.5 jr-flex jr-items-center", { 'jr-bg-primary-light jr-text-primary': _ctx.isTransportation, 'jr-text-white': !_ctx.isTransportation }])
                }, [
                  _withDirectives(_createElementVNode("img", _hoisted_11, null, 512), [
                    [_vShow, !_ctx.sbMinimum && !_ctx.isTransportation]
                  ]),
                  _withDirectives(_createElementVNode("img", _hoisted_12, null, 512), [
                    [_vShow, !_ctx.sbMinimum && _ctx.isTransportation]
                  ]),
                  _withDirectives(_createElementVNode("img", _hoisted_13, null, 512), [
                    [_vShow, !_ctx.isTransportation]
                  ]),
                  _withDirectives(_createElementVNode("img", _hoisted_14, null, 512), [
                    [_vShow, _ctx.isTransportation]
                  ]),
                  _withDirectives(_createElementVNode("h1", _hoisted_15, "交通手段比率", 512), [
                    [_vShow, !_ctx.sbMinimum]
                  ])
                ], 2)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/area_report/facilities",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onClickLink('エリア内の訪問施設分析')))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["jr-py-3.5 jr-px-5.5 jr-flex jr-items-center", { 'jr-bg-primary-light jr-text-primary': _ctx.isFacilities, 'jr-text-white': !_ctx.isFacilities }])
                }, [
                  _withDirectives(_createElementVNode("img", _hoisted_16, null, 512), [
                    [_vShow, !_ctx.sbMinimum && !_ctx.isFacilities]
                  ]),
                  _withDirectives(_createElementVNode("img", _hoisted_17, null, 512), [
                    [_vShow, !_ctx.sbMinimum && _ctx.isFacilities]
                  ]),
                  _withDirectives(_createElementVNode("img", _hoisted_18, null, 512), [
                    [_vShow, !_ctx.isFacilities]
                  ]),
                  _withDirectives(_createElementVNode("img", _hoisted_19, null, 512), [
                    [_vShow, _ctx.isFacilities]
                  ]),
                  _withDirectives(_createElementVNode("h1", _hoisted_20, "エリア内の訪問施設分析", 512), [
                    [_vShow, !_ctx.sbMinimum]
                  ])
                ], 2)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/area_report/timing",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onClickLink('エリア内の滞在時間')))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["jr-py-3.5 jr-px-5.5 jr-flex jr-items-center", { 'jr-bg-primary-light jr-text-primary': _ctx.isTiming, 'jr-text-white': !_ctx.isTiming }])
                }, [
                  _withDirectives(_createElementVNode("img", _hoisted_21, null, 512), [
                    [_vShow, !_ctx.sbMinimum && !_ctx.isTiming]
                  ]),
                  _withDirectives(_createElementVNode("img", _hoisted_22, null, 512), [
                    [_vShow, !_ctx.sbMinimum && _ctx.isTiming]
                  ]),
                  _withDirectives(_createElementVNode("img", _hoisted_23, null, 512), [
                    [_vShow, !_ctx.isTiming]
                  ]),
                  _withDirectives(_createElementVNode("img", _hoisted_24, null, 512), [
                    [_vShow, _ctx.isTiming]
                  ]),
                  _withDirectives(_createElementVNode("h1", _hoisted_25, "エリア内の滞在時間", 512), [
                    [_vShow, !_ctx.sbMinimum]
                  ])
                ], 2)
              ]),
              _: 1
            }),
            (_ctx.showAreaVisitor === 1)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "/area_report/visitor",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onClickLink('エリア来訪者の属性')))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["jr-py-3.5 jr-px-5.5 jr-flex jr-items-center", { 'jr-bg-primary-light jr-text-primary': _ctx.isVisitor, 'jr-text-white': !_ctx.isVisitor }])
                    }, [
                      _withDirectives(_createElementVNode("img", _hoisted_26, null, 512), [
                        [_vShow, !_ctx.sbMinimum && !_ctx.isVisitor]
                      ]),
                      _withDirectives(_createElementVNode("img", _hoisted_27, null, 512), [
                        [_vShow, !_ctx.sbMinimum && _ctx.isVisitor]
                      ]),
                      _withDirectives(_createElementVNode("img", _hoisted_28, null, 512), [
                        [_vShow, !_ctx.isVisitor]
                      ]),
                      _withDirectives(_createElementVNode("img", _hoisted_29, null, 512), [
                        [_vShow, _ctx.isVisitor]
                      ]),
                      _withDirectives(_createElementVNode("h1", _hoisted_30, "エリア来訪者の属性", 512), [
                        [_vShow, !_ctx.sbMinimum]
                      ])
                    ], 2)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", {
        class: _normalizeClass(["jr-w-full jr-cursor-pointer jr-relative", { 'jr-flex jr-items-center jr-justify-center': _ctx.loadingDetail }])
      }, [
        (_ctx.loadingDetail && !_ctx.loaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31))
          : _createCommentVNode("", true),
        (!_ctx.loadingDetail && _ctx.loaded)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: "/area_report/same_day_action",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onClickLink('同日行動')))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["jr-p-6 jr-flex jr-items-center", { 'jr-bg-primary-light jr-text-primary': _ctx.isSameDay, 'jr-text-white': !_ctx.isSameDay }])
                }, [
                  _withDirectives(_createElementVNode("img", _hoisted_32, null, 512), [
                    [_vShow, !_ctx.isSameDay]
                  ]),
                  _withDirectives(_createElementVNode("img", _hoisted_33, null, 512), [
                    [_vShow, _ctx.isSameDay]
                  ]),
                  _withDirectives(_createElementVNode("h1", _hoisted_34, "同日行動", 512), [
                    [_vShow, !_ctx.sbMinimum]
                  ])
                ], 2)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", {
        class: "btn_close",
        style: _normalizeStyle({ transform: (_ctx.sbMinimum ? 'rotate(180deg)' : 'rotate(0deg)') })
      }, [
        _createElementVNode("a", {
          href: "javascript:void(0)",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onClickClose && _ctx.onClickClose(...args)))
        }, _hoisted_37)
      ], 4)
    ])
  ], 4))
}